module.exports = __webpack_public_path__ + "img/products/step-04.png";